import React from "react";
import { ModeRendererProps } from "./types";

export function TinguelyGearsMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <g transform="translate(397 540)">
        {/* Central large gear cluster */}
        <use href="#gearLarge" transform="scale(2)" />
        
        {/* Orbiting gears */}
        {Array.from({ length: 8 }).map((_, i) => {
          const angle = (i * Math.PI * 2) / 8;
          const radius = 180;
          const x = radius * Math.cos(angle);
          const y = radius * Math.sin(angle);
          return (
            <g key={i} transform={`translate(${x} ${y}) rotate(${i * 45})`}>
              <use href="#gear" />
              {i % 2 === 0 && (
                <>
                  <line x1="0" y1="0" x2="60" y2="0" stroke={brand.violet} strokeWidth="3" />
                  <use href="#gear" transform="translate(60 0) scale(0.7)" />
                </>
              )}
            </g>
          );
        })}
        
        {/* Intermediate connecting gears */}
        {Array.from({ length: 8 }).map((_, i) => {
          const angle = ((i + 0.5) * Math.PI * 2) / 8;
          const radius = 120;
          const x = radius * Math.cos(angle);
          const y = radius * Math.sin(angle);
          return (
            <use key={`mid-${i}`} href="#gear" transform={`translate(${x} ${y}) scale(0.6) rotate(${-i * 30})`} />
          );
        })}
        
        {/* Energy circles */}
        {Array.from({ length: 5 }).map((_, i) => (
          <circle
            key={i}
            r={60 + i * 50}
            fill="none"
            stroke={i % 2 ? brand.aqua : brand.amber}
            strokeWidth="1"
            strokeDasharray="5 10"
            opacity={0.3}
          />
        ))}
      </g>
    </g>
  );
}
